import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ssf-switch-button',
    template: require('./switch-button.component.html'),
    styles: [require('./switch-button.component.scss')]
})
export class SwitchButtonComponent {
    /**
     * If this is true, check event is not fired by this component. Instead, parrent component manipulates the state
     * of this button by changing isOn input.
     */
    @Input() usingManualTriggering: boolean;
    /**
     * State of the switch ON/OFF.
     */
    @Input() isOn: boolean;
    /**
     * If disabled, switching is forbidden.
     */
    @Input() disabled: boolean;
    /**
     * Text to be shown in a tooltip, when the button is disabled. If any text is present, the tooltip will be shown,
     * empty string won't cause tooltip to appear.
     */
    @Input() disabledTooltipText: string;
    /**
     * Position of a tooltip shown when the button is disabled. Supports 'top', 'right', 'bottom', 'left' and 'auto'.
     * Check https://valor-software.com/ngx-bootstrap/?gclid=CjwKCAjw54fdBRBbEiwAW28S9mc11oAMUgEdqU5I31Hluk2wo6ml20Eux
     * -QJzQ1GXKfHshMG8VUA8hoCtPQQAvD_BwE#/tooltip for details. Default is top.
     */
    @Input() disabledTooltipPlacement: string;
    /**
     * Determines whether to also use text labels to describe state of the switch.
     */
    @Input() withLabels: boolean;

    /**
     * Determines whether to open confirm popup or not.
     */
    @Input() popup: boolean;

    /**
     * Determines if the button is used in bankId tab.
     */
    @Input() isBankId: boolean;

    /**
     * Signals the state of the button after clicking it.
     */
    @Output() check = new EventEmitter<boolean>();
    public i18n = 'SHARED.SWITCH-BUTTON.';

    checkButton() {
        if (!this.disabled && !this.usingManualTriggering) {
            if (!this.popup) {
                this.isOn = !this.isOn;
            }
            this.check.emit(this.isOn);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/switch-button/switch-button.component.ts